<template>
      <div app class="topbar" style="background-color: white; box-shadow: 5px 4px 10px 0px #cfcfcf;">
        <v-container>
          <!-- ten index jde vidět jen když user není loglej, když je tak mu tam hod jeho homepage -->
          <v-row class="align-center">
            <v-col md="7" cols="12">
              <v-toolbar-title class="text-uppercase font-weight-bold  font-poppins-heading"><a href="/" class="text-lightGreen text-decoration-none">Vegamenu</a></v-toolbar-title>
              <v-spacer class="d-none d-md-block"></v-spacer>
            </v-col>
            <v-col md="5" cols="12">
              <v-btn
                class="ma-2 font-readex px-6 rounded-lg"
                color="lightGreen"
                dark
                link
                outlined
                :to="{name: 'register'}"
              >
                Registrace
              </v-btn>
              <v-btn
                class="ma-2 font-readex px-6 rounded-lg"
                color="lightGreen"
                outlined
                dark
                link
                :to="{name: 'quick-register'}"
              >
                Rychlá registrace
              </v-btn>
              <v-btn
                class="ma-2 font-readex px-6 rounded-lg"
                color="lightGreen"
                dark
                :to="{name: 'login'}"
                link
              >
                Přihlásit se
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
</template>

<script>
export default {
  name: 'IndexNav'
}
</script>

<style scoped>

</style>
